/**
 * @file status-meta.ts
 * @description Реестры статусов кабинета платформы (phase19.29): подпись и
 * вариант «пилюли» для статуса интеграции и запуска бэкапа.
 *
 * Общие для страниц разделов и «Обзора» — чтобы «активна» и «Успешно»
 * выглядели одинаково везде. Тона — шесть статусов UI-системы Commora
 * (пилюля с точкой и текстом): `success` (успех), `info` (в работе),
 * `warning` (внимание), `destructive` (ошибка), `special` (особое/AI),
 * `neutral` (неактивно). Новый статус = запись здесь, не ветка в разметке.
 */

import type { BadgeProps } from "../ui/badge";
import type { BackupRunDto } from "../../lib/api-backups";
import type { PlatformIntegrationStatus } from "../../lib/api-platform-integrations";

export type StatusBadgeVariant = NonNullable<BadgeProps["variant"]>;

export interface StatusMeta {
  label: string;
  variant: StatusBadgeVariant;
}

/** Статус экземпляра интеграции. */
export const INTEGRATION_STATUS_META: Record<PlatformIntegrationStatus, StatusMeta> = {
  ACTIVE: { label: "активна", variant: "success" },
  PAUSED: { label: "на паузе", variant: "warning" },
  ERROR: { label: "ошибка", variant: "destructive" },
  NOT_CONFIGURED: { label: "не подключена", variant: "neutral" },
};

/** Статус учётной записи пользователя платформы. */
export const USER_STATUS_META: Record<"active" | "disabled", StatusMeta> = {
  active: { label: "активен", variant: "success" },
  disabled: { label: "отключён", variant: "neutral" },
};

/** Вариант «пилюли» статуса запуска бэкапа (подписи — `RUN_STATUS_LABEL`). */
export const BACKUP_RUN_BADGE: Record<BackupRunDto["status"], StatusBadgeVariant> = {
  SUCCESS: "success",
  FAILED: "destructive",
  RUNNING: "info",
};
